import React, { Component } from 'react';

export default class RoomRatesContainer extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };
    }

    componentDidMount() {
        this.populateData();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.checkIn !== this.props.checkIn
            || prevProps.nights !== this.props.nights
            || prevProps.promoCode !== this.props.promoCode
            || prevProps.adults !== this.props.adults
            || prevProps.children != this.props.children
            )
        {
            this.populateData();
        }
        
    }



    renderLayout() {
        return (

            this.state.data.map((roomPrice) =>
                <RoomRateContainer
                    key={roomPrice.ratePlanName}
                    publishedPrice={roomPrice.price}
                    promoWindowPrice={roomPrice.promoWindowPrice }
                    roomPrice={roomPrice}
                    roomType={this.props.roomType}
                    select={this.props.select}
                    rooms={this.props.rooms}
                    selectedRooms={this.props.selectedRooms}
                    mode={this.props.mode} //select/add/change
                />)

        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderLayout();

        return (
            <div className='room-rates-container col-vs-12 col-sm-4'>
                {contents}
            </div>
        );
    }

    async populateData() {
        let url = 'api/rates?propertyKey=' + this.props.propertyKey + '&roomTypeUId=' + this.props.roomType.uId +
            '&checkIn=' + this.props.checkIn +
            '&nights=' + this.props.nights +
            '&promoCode=' + this.props.promoCode +
            '&adults=' + this.props.adults +
            '&children=' + this.props.children;

        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {

                this.setState({
                    data: data,
                    loading: false
                });
                                
            }).catch(error => {
                console.log(error);
            });
    }
}

export function RoomRateContainer (props) {

    const isSelected = () => (

        props.selectedRooms.find(sr => sr.roomType?.uId === props.roomType.uId && sr.roomPrice.ratePlanName === props.roomPrice.ratePlanName)

    )

    const roomIndex = () => (

        props.selectedRooms.indexOf(sr => sr.roomType?.uId === props.roomType.uId && sr.roomPrice.ratePlanName === props.roomPrice.ratePlanName)

    )

    function nth(i) {

        var ordinals = [
            'First', 'Second', 'Third', 'Forth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth', 'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Fifteenth', 'Sixteenth', 'Seventeenth', 'Eighteenth', 'Nineteenth', 'Twentieth'];

        return ordinals[i];

    }
        
    return (
        <div className='room-rate-container'>
                
                
                
                <div>
                        
                        <button
                            type='button'
                            className={isSelected() ? 'btn btn-dark btn-block' : 'btn btn-light btn-block'}
                            disabled={props.roomPrice.nights < props.roomPrice.minStay}
                            onClick={() => props.select(props.roomType, props.roomPrice)} >
                        {
                        <div class="row justify-content-end">
                            <div class="col-5">
                                <div class="row small justify-content-start">
                                    <div class="col small text-left">
                                        {isSelected() &&

                                            <span>
                                                Selected <br />

                                                Adults: {isSelected().roomPrice.adults} <br />

                                                Children: {isSelected().roomPrice.children}

                                            </span>
                                        }
                                        {props.roomPrice.nights < props.roomPrice.minStay &&
                                            <span className='text-danger'>Minimum stay of {props.roomPrice.minStay} nights required</span>
                                        }
                                        {!isSelected() &&

                                            <span><h3>Reserve</h3></span>
                                        }

                                    </div>
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="row justify-content-end">
                                    <div class="col text-right">{props.roomPrice.ratePlanName}</div>
                                    {props.roomPrice.mealPlan && <div class="col text-right">{props.roomPrice.mealPlan.name}</div>}
                                </div>
                                <div className="row justify-content-end">
                                    <div
                                        className="col text-right"
                                        style={{
                                            height: 40,
                                            position: "relative"
                                        }}
                                    >
                                        {props.publishedPrice > props.roomPrice.promoCodePrice && (
                                            <span
                                                className="text-danger"
                                                style={{
                                                    position: "absolute",
                                                    right: "110px",
                                                    top: "-6px",
                                                    fontSize: "1rem",
                                                    textDecoration: "line-through",
                                                    fontWeight: "normal",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                £{props.promoWindowPrice.toFixed(0)}
                                            </span>
                                        )}

                                        <h4 style={{ margin: 0 }}>
                                            £{props.roomPrice.promoCodePrice.toFixed(2)}
                                        </h4>
                                    </div>
                                </div>
                                <div className="row small justify-content-end" >
                                    <div class="col small text-right">
                                        {"room rate for " + props.roomPrice.nights.toString() + (props.roomPrice.nights === 1 ? " night" : " nights")}
                                    </div>
                                </div>
                                <div class=" row small justify-content-end">
                                    <div class="col text-right text-danger"><i>
                                        {props.roomPrice.promoCode === "" ? "" : props.roomPrice.promoCode + " applied"}</i>
                                    </div>
                                </div>
                            </div>
                        </div>}
                                
                        </button>
                            
                        
                </div>
                
                
        </div>
    );
    

    
}
